import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getRatingDetails } from '../../actions/editordashboard'
import { Link } from 'react-router-dom'
import classname from 'classnames'

class RatingDetails extends Component {
    constructor(props) {
        super(props)
    }
    componentDidMount(props) {
        this.getRatingDetails(this.props.params.DocID);
    }
    getRatingDetails(body){
      this.props.dispatch(getRatingDetails(body));
    }
    render() {
      return (
        <div>
          <div className="dashboardpaperdetails">
            <br/>
            <div> Rating Date: {this.props.Dashboard.rating_details.rating_date} </div>
            <br/>
            <div> Star Rating: {this.props.Dashboard.rating_details.rating_star} </div>
            <br/>
            <div> Rating Comment: {this.props.Dashboard.rating_details.rating_comment} </div>
            <br/>
            <span><Link to="/home/dashboard/editor/">Back</Link></span>
          </div>
        </div>
      )
    }
}

export default connect( ({Dashboard}) => ({Dashboard}) ) (RatingDetails)



// WEBPACK FOOTER //
// ./src/components/dashboards/EditorRatingDetails.js